import {
  FetchAnswersRequest,
  FetchAnswersResponse,
  GetAnswerRequest,
  GetAnswerResponse,
} from "@coffee/data-access/api-types";
import { policyqaApi } from "./policyqaApi";

export const { useGetAnswerMutation, useFetchAnswersQuery } =
  policyqaApi.injectEndpoints({
    endpoints: (builder) => ({
      getAnswer: builder.mutation<GetAnswerResponse, GetAnswerRequest>({
        query: (body) => {
          return {
            url: "v1/experimental/domains/c0ff33c0-ff33-4c0f-f38c-0ff33c0ff33c/versions/c0ff33c0-ff33-4c0f-f38c-0ff33c0ff33c/answers",
            method: "POST",
            body,
          };
        },
      }),
      fetchAnswers: builder.query<FetchAnswersResponse, FetchAnswersRequest>({
        query: ({ answerIds }) => {
          const queryString = answerIds
            .map((id) => `answer_ids=${encodeURIComponent(id)}`)
            .join("&");
          return {
            url: `v1/experimental/domains/c0ff33c0-ff33-4c0f-f38c-0ff33c0ff33c/versions/c0ff33c0-ff33-4c0f-f38c-0ff33c0ff33c/answers?${queryString}`,
            method: "GET",
          };
        },
      }),
    }),
  });
